import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "@/lib/useApi";
import { useAuth } from "@/context/AuthContext";
import { FeaturedBanner } from "@/components/FeaturedBanner";
import { VideoRow } from "@/components/VideoRow";
import { LoginModal } from "@/components/LoginModal";

export default function Home({ loginOpen = false }) {
  const { data } = useApi("/home");
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loginOpen && user) navigate("/admin", { replace: true });
  }, [loginOpen, user, navigate]);

  return (
    <div data-testid="home-page">
      {data?.featured && <FeaturedBanner featured={data.featured} />}
      {data?.rows?.map((row) => (
        <VideoRow key={row.id} title={row.name} videos={row.videos} testId={`home-row-${row.id}`} />
      ))}
      {data && data.rows.length === 0 && (
        <p className="mt-16 text-[16px] text-[#8A8A8A]" data-testid="home-empty">
          No videos yet. Add videos and categories from Admin Settings.
        </p>
      )}
      <LoginModal open={loginOpen && !user} />
    </div>
  );
}
